import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const QUERY = gql`
  query CustomerResource($customerId: ID!, $resourceId: ID) {
    customerResource(customerId: $customerId, resourceId: $resourceId) {
      ...PerformanceCenterCustomerResource
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

export const queryCustomerResource = async ({ customerId, resourceId }) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      resourceId,
    },
  });

  const data = getSingleProp(result.data);
  return data?.[0];
};
